export default "__VITE_ASSET__BnwgC5e6__"